export enum ReportReasonCatalogSystem {
  ItemIllegal = 'ITEM-ILLEGAL-CATALOG-SYSTEM',
  ItemSexual = 'ITEM-SEXUAL-CATALOG-SYSTEM',
  ItemHygiene = 'ITEM-HYGIENE-CATALOG-SYSTEM',
  ItemRestricted = 'ITEM-RESTRICTED-CATALOG-SYSTEM',
  ItemHealthRisk = 'ITEM-HEALTH-RISK-CATALOG-SYSTEM',
  ItemScam = 'ITEM-SCAM-CATALOG-SYSTEM',
  ItemObviousCounterfeits = 'ITEM-OBVIOUS-COUNTERFEITS-CATALOG-SYSTEM',
  ItemCounterfeits = 'ITEM-COUNTERFEITS-CATALOG-SYSTEM',
  ItemOnlineAuth = 'ITEM-ONLINE-AUTH-CATALOG-SYSTEM',
}

export const REPORT_REASONS_WITH_BRAND: Array<ReportReasonCatalogSystem> = [
  ReportReasonCatalogSystem.ItemObviousCounterfeits,
  ReportReasonCatalogSystem.ItemCounterfeits,
  ReportReasonCatalogSystem.ItemOnlineAuth,
]
